module.exports = __webpack_public_path__ + "img/gestures.24618925.svg";